export default "__VITE_ASSET__BRCW$X2Z__"